module.exports = __webpack_public_path__ + "static/media/android_china.7812bcbe.png";